import { css, html, LitElement } from 'lit';
import { WEB_CONTENT } from '../../../../constants/content';
import { Image } from '../../Image/Image';
class ReactionsInfoCard extends LitElement {
  static properties = {
    reactionType: { type: String },
    userName: { type: String },
    userProfileImage: { type: String },
    isSelfReaction: { type: String },

    bgColor: { type: String },
    color: { type: String },
    borderRadius: { type: String },
    border: { type: String },
    fontSize: { type: String },
    height: { type: String },
    width: { type: String },

    imageRadius: { type: String },
    imageHeight: { type: String },
    imageWidth: { type: String },
  };

  static styles = css`
    .reaction-info-card-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px;
      border-radius: 4px;
      gap: 10px;
    }

    .reaction-info-username-container {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
  `;

  handleRemoveClick() {
    this.dispatchEvent(new CustomEvent('remove-click', {
      detail: {
        reactionType: this.reactionType,
      },
      bubbles: true,
      composed: true
    }));
  }
  render() {
    const emojis = [
      { id: 'star', src: '⭐' },
      { id: 'crying_with_laughter', src: '😂' },
      { id: 'yes', src: '👍' },
      { id: 'no', src: '❌' },
      { id: 'party', src: '🥳' },
      { id: 'high_five', src: '✋' },
      { id: 'rock', src: '🪨' },
      { id: 'facepal', src: '🤦' },
      { id: 'sarcastic', src: '🙄' },
      { id: 'talking_too_much', src: '🤫' },
      { id: 'crying', src: '😭' },
      { id: 'heart', src: '❤️' },
      { id: 'surprised', src: '😮' },
      { id: 'bowing', src: '🙇' },
    ];
    const matchingEmoji = emojis.find(emoji => emoji.id === this.reactionType)?.src || '';

    const emojiSize = `calc(${this.fontSize} + 4px)`;
    const seondarySize = `calc(${this.fontSize} - 6px)`;
    return html`
      <div
        class="reaction-info-card-container"
        style="background-color: ${this.bgColor}; color: ${this.color}; border: ${this.border};
      border-radius: ${this.borderRadius}; height: ${this.height}; width: ${this.width};"
      >
        <div class="reaction-info-user-image">
          ${Image({
            src: this.userProfileImage,
            height: this.imageHeight,
            width: this.imageWidth,
            borderRadius: this.imageRadius,
            objectFit: 'cover',
          })}
        </div>
        <div class="reaction-info-username-container">
          <div class="reaction-info-username" style="font-size: ${this.fontSize}">${this.userName}</div>
          ${this.isSelfReaction
            ? html`<div @click=${this.handleRemoveClick} style="cursor: pointer; font-size: ${seondarySize}">${WEB_CONTENT.REACTIONS.REMOVE_REACTION_ON_TAP}</div>`
            : null}
        </div>
        <div class="reaction-info-emoji" style="font-size: ${emojiSize}">${matchingEmoji}</div>
      </div>
    `;
  }
}

customElements.define('reactions-info-card', ReactionsInfoCard);
